module.exports = __webpack_public_path__ + "images/emoji/heavy_division_sign.0f0262de3daff436ede4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/heavy_division_sign.png
// module id = mLPv
// module chunks = 13